<template>
  <!-- 주문상세 내역 -->
  <div class="columns is-multiline">
    <div class="column is-6">
      <div class="box">
        <admin-box-item title="1:1 문의 내용" subtitle="런치팩 1:1문의에 등록된 문의글의 내용을 불러옵니다.">
          <div class="columns is-multiline">
            <div class="column is-full">
              <admin-form-item label="서비스명">{{ inquiry.service_name }}</admin-form-item>
            </div>
          </div>
          <div class="column is-full">
            <admin-form-item label="문의유형">
              {{ inquiry.cat }}
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="작성일">
              {{ inquiry.created_time }}
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="제목">
              {{ inquiry.title }}
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="내용">
              <div v-html="inquiry.content"></div>
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="$route.query.id && inquiry.imgs.length>0">
            <admin-form-item label="첨부 파일">
              <a v-for="(file,idx) in inquiry.imgs" :key="'file-'+idx" style="text-decoration: underline" :href="file" target="_blank" download>
                <img :src="file" style="border:1px solid #ddd;max-height:600px">
              </a>
            </admin-form-item>
          </div>
        </admin-box-item>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "OrderDetail",
    created() {
    },
    data() {
      return {
        inquiry: undefined
      }
    },
    methods: {}
  }
</script>
<style lang="stylus" scoped>
</style>
